export default "<h2>Ha acabado el período de prueba, por favor comuníquese con G&S Gestion y Sistemas.</h2>\r\n"